import { yupResolver } from "@hookform/resolvers/yup";
import { Container, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { listEquipmentSchema } from "constants/formValidation";
import ListEquipmentPublic from "pages/list-equipment-public";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  fetchAllAttachmentsAction,
  fetchAllManufacturerAction,
} from "slices/generalReducer";
import { useAppSelector } from "store/appHooks";
import InitialState from "./InitialState";
import Nav from "./Nav";
import BasicDetails from "./StepsContent/BasicDetails";
import Configurations from "./StepsContent/Configurations";
import ListingImages from "./StepsContent/ListingImages";
import Pricing from "./StepsContent/Pricing";
import UsageRates from "./StepsContent/UsageRates";
import { populateEditValues } from "./helpers";
import { error } from "console";
import { getUserProfile } from "slices/userReducer";

const Steps: any = {
  "Basic Details": (props: any) => <BasicDetails {...props} />,
  Configurations: (props: any) => <Configurations {...props} />,
  "Listing Images": (props: any) => <ListingImages {...props} />,
  "Usage Rates": (props: any) => <UsageRates {...props} />,
  Pricing: (props: any) => <Pricing {...props} />,
  // "Pricing and Usage Rates": (props: any) => <UsageRates {...props} />,
  // "Pricing and Approval Policy": (props: any) => (
  //   <PricingAndApprovalPolicy {...props} />
  // ),
};

const ListEquipment = (props: any) => {
  let [searchParams, setSearchParams] = useSearchParams();
  const editId = searchParams.get("id");

  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));

  const [currentStep, setCurrentStep] = useState("Basic Details");
  const [stepStatus, setStepStatus] = useState(
    Object?.keys(Steps)?.reduce((acc: any, el: any) => {
      acc[el] = { loading: false, submitted: false, error: false };
      return acc;
    }, {})
  );
  const { generalReducer }: any = useSelector((state) => state);

  const { manufacturer, attachments, models } = generalReducer;
  const { data: manufacturerData } = manufacturer;
  const { data: attachmentsData } = attachments;

  const navigate = useNavigate();
  const PageStep = Steps[currentStep];
  const dispatch: any = useDispatch();
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(listEquipmentSchema),
    defaultValues: InitialState,
  });

  const { authReducer }: any = useAppSelector((state) => state);
  const { isLoggedIn } = authReducer;

  const changeStepStatus = (step: any, k: any, v: any) => {
    setStepStatus((prev: any) => ({
      ...prev,
      [step]: {
        ...prev[step],
        [k]: v,
        ...(k == "submitted" && v && { error: false }),
        ...(k == "error" && v && { submitted: false }),
      },
    }));
  };

  useEffect(() => {
    dispatch(fetchAllManufacturerAction());
    dispatch(fetchAllAttachmentsAction());
    if (isLoggedIn) dispatch(getUserProfile());
  }, []);

  useEffect(() => {
    if (editId) {
      if (manufacturerData.length && attachmentsData.length) {
        populateEditValues(editId, methods?.setValue, dispatch, setStepStatus);
      }
    }
  }, [editId, manufacturerData, attachmentsData]);

  if (!isLoggedIn) {
    return <ListEquipmentPublic />;
  }

  const onSubmit = (data: any, e: any) => {
    console.log(data);
    e?.preventDefault();
  };

  return (
    <FormProvider {...methods}>
      <Container key={editId} style={{ padding: "8px 5px", maxWidth: "100%" }}>
        <Grid
          container
          spacing={0.5}
          justifyContent="center"
          alignItems="stretch"
        >
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <Nav
              items={Object.keys(Steps)}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              stepStatus={stepStatus}
              setStepStatus={setStepStatus}
              changeStepStatus={changeStepStatus}
              PageContent={
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                  <PageStep
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    generalReducer={generalReducer}
                    isMobileView={isMobileView}
                    stepStatus={stepStatus}
                    setStepStatus={setStepStatus}
                    changeStepStatus={changeStepStatus}
                    editId={editId}
                  />
                </form>
              }
              isMobileView={isMobileView}
              generalReducer={generalReducer}
            />
          </Grid>
          {!isMobileView && (
            <Grid
              item
              xs={0}
              sm={0}
              md={9}
              lg={9}
              xl={9}
              sx={{ display: "flex", flexDirection: "row" }}
            >
              <div
                style={{
                  borderLeft: "1px solid #e2e2e2",
                  height: "100%",
                  width: "1px",
                }}
              />
              <form onSubmit={methods.handleSubmit(onSubmit)}>
                <PageStep
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  generalReducer={generalReducer}
                  isMobileView={isMobileView}
                  stepStatus={stepStatus}
                  setStepStatus={setStepStatus}
                  changeStepStatus={changeStepStatus}
                  editId={editId}
                />
              </form>
            </Grid>
          )}
        </Grid>

        {/* <Grid container spacing={2}>
        <Grid item xs={3}>
          
        </Grid>
        <Grid item xs={9}>
         
        </Grid>
      </Grid> */}
      </Container>
    </FormProvider>
  );
};

export default ListEquipment;
